/*
 * @Date: 2022-05-23 13:38:50
 * @LastEditTime: 2022-08-08 19:51:26
 * @Description: file content
 * @FilePath: \traffic\src\utils\common.js
 */
import noSelectImg from '@/img/no-select.png';
import _ from 'lodash';

const isObject = (obj) => {
    return typeof obj === 'object' && obj !== null
  }
  
  export const isEqual = (obj1,obj2) => {
    // 两个数据有任何一个不是对象或数组
    if (!isObject(obj1) || !isObject(obj2)) {
      // 值类型(注意：参与equal的一般不会是函数)
      return obj1 === obj2
    }
    // 如果传的两个参数都是同一个对象或数组
    if (obj1 === obj2) {
      return true
    }
  
    // 两个都是对象或数组，而且不相等
    // 1.先比较obj1和obj2的key的个数，是否一样
    const obj1Keys = Object.keys(obj1)
    const obj2Keys = Object.keys(obj2)
    if (obj1Keys.length !== obj2Keys.length) {
      return false
    }
  
    // 如果key的个数相等,就是第二步
    // 2.以obj1为基准，和obj2依次递归比较
    for (let key in obj1) {
      // 比较当前key的value  --- 递归
      const res = isEqual(obj1[key], obj2[key])
      if (!res) {
        return false
      }
    }
  
    // 3.全相等
    return true
  }

  export const secondToChangeDepart = (data) => {
    try{
      const scope = JSON.parse(data?.scope)
      const scopeInfo = data?.scopeInfo
      if(scope) {
        const uidList = (scope?.uidList || [])?.map(item => Number(item))
        const deptIdList = (scope?.deptIdList || [])?.map(item => Number(item))
        const deptList = scopeInfo?.deptList || []
        const userList = scopeInfo?.userList || []
        const realDepartMentList = deptList?.reduce((result, item) => {
          const isIn = deptIdList.includes(item.id)
          return isIn ? [...result, { ...item, isLeaf: false, key: item.id, title: item.name }] : result
        }, [])
        const realUserList = uidList?.length > 0 ? userList?.map((item) => ({
          ...item,
          uid: item.id,
          isLeaf: true,
          key: `${item.id}isUser`,
          title: item.name,
        })) : [];
        return [...realDepartMentList, ...realUserList]
      }
    }
    catch(err) {
      return []
      // json格式可能有问题
    }
  }

export const isQD = () => {
  const access = JSON.parse(localStorage.getItem('useAccessData') || '{}');//crm-pc-frontend项目存储在localStorage中的三个权限接口值。api/pc/permissions、api/pc/custom_fields/permission_setting、api/pc/custom_features
  const isQiDianBrowser = window.navigator.userAgent.toLocaleLowerCase().includes('qidian');
  return (_.get(access, 'orgSettings.open_list.qidian') === true)  || document.cookie.includes('platform=qidian') || isQiDianBrowser;
}